import {useNavigate} from "react-router-dom";
import {AppTitle} from "shared/UI/UIKit/Title";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppText} from "shared/UI/UIKit/Text";
import {
  getAnnotationUrl,
  getInteractiveUrl,
  getLiteratureUrl, getMethodologicalModuleUrl, getPracticalModuleUrl,
  getTargetUrl, getTestUrl, getTheoryUrl,
  getVideoUrl
} from "services/navigation";
import type {PracticalModulePage, InteractivePage, MethodologicalModulePage} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

export const HomePage = () => {
  const navigate = useNavigate();
  // const authorsTitle = GLOBAL_CONFIG.home.authorsTitle;
  const authors = GLOBAL_CONFIG.home.authors;

  const getUrl = () => {
    const firstPage = GLOBAL_CONFIG.pages.find((page) => page.order === 1);

    if (firstPage) {
      switch (firstPage.type) {
        case PageType.ANNOTATION:
          return getAnnotationUrl();
        case PageType.INTERACTIVE:
          return getInteractiveUrl({id: (firstPage as InteractivePage).id});
        case PageType.LITERATURE:
          return getLiteratureUrl();
        case PageType.TARGET:
          return getTargetUrl();
        case PageType.TEST:
          return getTestUrl();
        case PageType.THEORY:
          return getTheoryUrl();
        case PageType.VIDEO:
          return getVideoUrl();
        case PageType.METHODOLOGICAL_MODULE:
          return getMethodologicalModuleUrl({id: (firstPage as MethodologicalModulePage).id});
        case PageType.PRACTICAL_MODULE:
          return getPracticalModuleUrl({id: (firstPage as PracticalModulePage).id});
        default:
          return getVideoUrl();
      }
    }
  };

  const start = () => {
    const url = getUrl() || null;

    if (url) {
      navigate(url);
    }
  };

  return (
    <AppFlex direction="row" className={styles.mainContentWrapper}>
      <AppFlex className={styles.contentWrapper}
               style={{backgroundImage: `url(${GLOBAL_CONFIG.home.imagePath})`, backgroundSize: "100%"}}>
        <AppFlex className={styles.content} >
          <AppTitle level={1} className={styles.title}>
            {/*<span>{GLOBAL_CONFIG.home.title}</span>*/}
          </AppTitle>
          <AppFlex direction="row" justifyContent="space-between">
            <AppButton size="large" style={{backgroundColor: "#FBE11C", borderColor: "#FBE11C", color: "black", marginLeft: "40px"}} onClick={start}>
              Начать
            </AppButton>
          </AppFlex>
        </AppFlex>
      </AppFlex>
      <AppFlex className={styles.authorColumn}>
        {/*<AppText size={20} className={styles.authorTitle} secondary>{authorsTitle}</AppText>*/}
        <AppFlex className={styles.authorList}>
          {authors.map((item, idx) => (
            <AppFlex className={styles.authorCard} key={idx} alignItems="center">
              <AppFlex className={styles.authorInfo}>
                <img className={styles.authorImg} src={item.imageSrc}/>
                <AppFlex className={styles.author}>
                  <AppText size={20} secondary className={styles.fio} style={{fontWeight: "bold"}}>{item.author}</AppText>
                  <AppText size={20} secondary className={styles.grade}>{item.grade}</AppText>
                  <AppText size={20} secondary>{item.subGrade}</AppText>
                </AppFlex>
              </AppFlex>
            </AppFlex>
          ))}
        </AppFlex>
      </AppFlex>
    </AppFlex>
  );
};

